module.exports = "/images/arrow-down.svg?c9295bac61a4e71542da3f5e56d76923";